import {lookupProfSpac} from '../../../constants/url';
import {useUtilInformation} from '../../../components/hooks/index';
import axios from 'axios';

async function useLoadLookupProfSpac() {
  const {token} = useUtilInformation();
  try {
    const response = await axios.get(`${lookupProfSpac}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default useLoadLookupProfSpac;
